import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
	{
	  path: "/",
	  name: "index",
	  component: () => import("@/views/index/index.vue")
	},
	{
	  path: "/job",
	  name: "job",
	  component: () => import("@/views/job/job.vue")
	},
	{
	  path: "/news",
	  name: "news",
	  component: () => import("@/views/news/news.vue")
	},
	{
	  path: "/course",
	  name: "course",
	  component: () => import("@/views/course/course.vue")
	},
	{
	  path: "/study",
	  name: "study",
	  component: () => import("@/views/course/study.vue")
	},
	{
	  path: "/personal",
	  name: "personal",
	  component: () => import("@/views/personal/personal.vue")
	}
]

export default new Router({
  mode: "history",
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});